'use client'
import { useState } from 'react'
import { login } from '@/lib/api'
import Link from 'next/link'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const data = await login(email, password)
      localStorage.setItem('token', data.access_token)
      window.location.href = '/'
    } catch {
      setError('Invalid email or password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-sm mx-auto mt-16">
      <div className="text-[10px] tracking-[0.4em] text-blue-400/50 uppercase mb-6 text-center">
        // PRISM Access Control
      </div>
      <div className="border border-blue-900/60 bg-[#070d1a] rounded-lg p-8 glow-border">
        <h1 className="text-lg font-bold text-white mb-1 tracking-wider">
          SYSTEM ACCESS
        </h1>
        <p className="text-blue-400/40 text-xs tracking-widest uppercase mb-6">
          Predictive Risk Intelligence System
        </p>

        {error && (
          <div className="border border-red-500/40 bg-red-500/10 text-red-400 text-xs p-3 rounded mb-4 tracking-wide">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-[10px] text-blue-400/50 mb-1 tracking-widest uppercase">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full bg-[#050a14] border border-blue-900/50 focus:border-blue-500/60 rounded px-3 py-2 text-blue-100 text-sm outline-none transition tracking-wide"
              required
            />
          </div>
          <div>
            <label className="block text-[10px] text-blue-400/50 mb-1 tracking-widest uppercase">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-[#050a14] border border-blue-900/50 focus:border-blue-500/60 rounded px-3 py-2 text-blue-100 text-sm outline-none transition"
              required
            />
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-blue-600/20 hover:bg-blue-600/40 border border-blue-500/60 text-blue-300 py-2 rounded transition text-xs tracking-widest uppercase disabled:opacity-50"
          >
            {loading ? 'Authenticating...' : 'Access System'}
          </button>
        </div>

        <div className="h-px bg-blue-900/30 my-6"></div>

        <p className="text-center text-xs text-blue-400/30 tracking-wider">
          No account?{' '}
          <Link href="/register" className="text-blue-400/60 hover:text-blue-300 transition">
            Request Access
          </Link>
        </p>
      </div>
    </div>
  )
}